import React from 'react';
import PropTypes from 'prop-types';
import Sidebar from 'react-sidebar';
import StickyDiv from 'components/StickyDiv';
import AdCaller from 'helpers/ads/adCaller';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
// import s from './Comments.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import CommentItem from './CommentItem';
import BottomCommentItem from './BottomCommentItem';
import BottomCommentItemV2Loader from './BottomCommentItemV2Loader';
import CommentWriteBox from './CommentWriteBox';
import { bindGa } from '../../../../../helpers/analytics';
import { isTablet } from '../../../../../utils/common';
import { RATE_TYPE } from '../../../../../modules/WithComments/config';

class Comments extends React.Component {
  constructor() {
    super();
    this.state = {
      openedAddCommentBoxId: '',
      showLoadMoreLoader: false,
      showChangeViewLoader: false,
      showFixedHeader: false,
      showFixedHeaderIcon: false,
      highlightedId: '',
      dynAdid: 0,
    };
    this.renderCommentList = this.renderCommentList.bind(this);
    this.onSidebarOpenClose = this.onSidebarOpenClose.bind(this);
    this.renderLogin = this.renderLogin.bind(this);
    this.openLoginBox = this.openLoginBox.bind(this);
    this.renderUserIcon = this.renderUserIcon.bind(this);
    this.loadMoreComments = this.loadMoreComments.bind(this);
    this.handleFixedHeader = this.handleFixedHeader.bind(this);
    this.onSortClick = this.onSortClick.bind(this);
    this.postCommentHandler = this.postCommentHandler.bind(this);
    this.readCommentHandler = this.readCommentHandler.bind(this);
    this.childRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.commentIdHighlighted !== prevProps.commentIdHighlighted) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ highlightedId: this.props.commentIdHighlighted });
    }
  }

  createChildRef = () => {
    if (
      this.childRef.current &&
      this.childRef.current.resetCommentBox &&
      typeof this.childRef.current.resetCommentBox === 'function'
    ) {
      this.childRef.current.resetCommentBox();
    }
  };

  onFlagClick = data => {
    // if (!this.props.isUserLoggedin(this.props.userData)) {
    //   this.openLoginBox(true);
    //   return;
    // }

    const { isValidRating } = this.props;

    const validationData = isValidRating(
      data.A_ID,
      RATE_TYPE.OFFENSIVE,
      1,
      data._id,
    );
    if (!validationData.isValid) {
      //show error
      this.setState({
        [`errorMsg-${data._id}`]: validationData.errorMsg,
      });
      return;
    }
    this.setState({
      [`errorMsg-${data._id}`]: '',
      activeFlag: data._id,
    });
  };

  onVote = (data, agreed) => {
    if (!this.props.isUserLoggedin(this.props.userData)) {
      this.openLoginBox(true);
      return;
    }

    const voteType = agreed ? 'AGREED' : 'DISAGREED';

    const { isValidRating } = this.props;

    const voteCount = (agreed ? data.AC_A_C : data.AC_D_C) + 1;
    const validationData = isValidRating(
      data.A_ID,
      voteType,
      voteCount,
      data._id,
    );
    if (!validationData.isValid) {
      //show error
      this.setState({
        [`errorMsg-${data._id}`]: validationData.errorMsg,
      });
      return;
    }

    this.setState({
      [`errorMsg-${data._id}`]: '',
    });

    this.props.putVote(data._id, voteType, voteCount, data.msid);
    // const updatedData = { ...this.state.data, AC_A_C: voteCount };
    // this.setState({
    //   data: updatedData,
    // });
  };

  openAddCommentBox = id => {
    this.setState({ openedAddCommentBoxId: id || '' });
  };

  resetCommentBoxId = () => {
    this.setState({ openedAddCommentBoxId: '' });
  };

  renderUserIcon(thumb, ga) {
    const s = this.props.styles;
    const thumbImg =
      thumb || 'https://mytimes.indiatimes.com/image/thumb/0/default';
    const userIcon = {
      backgroundImage: `url(${thumbImg})`,
      backgroundSize: `cover`,
    };

    return <span className={s.user_thumbnail} style={userIcon} data-ga={ga} />;
  }

  showThread = id => {
    // this.setState({
    //   sidebarOpen: true,
    // });
    if (!this.props.isWapView) {
      analyticsWrapper(
        'gaAndGrx',
        'send',
        'event',
        '',
        'LB_sticky_comments',
        '',
      );
    }
    this.props.openSidebar(this.props.msid);
    if (!isTablet()) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }

    this.setState({ highlightedId: id });
    this.handleCallbak(!(this.props?.sidebarOpenMsid === this.props.msid));
  };

  hideFlag = () => {
    this.setState({
      activeFlag: '',
    });
  };

  getCommentItem(item, i, parent = {}, level) {
    const isParent =
      !parent ||
      (typeof parent === 'object' && Object.keys(parent).length === 0);
    return (
      <CommentItem
        parent={parent}
        userData={this.props.userData}
        isUserLoggedin={this.props.isUserLoggedin}
        openLoginBox={this.openLoginBox}
        pageMsid={this.props.msid}
        key={item._id}
        renderCommentList={this.renderCommentList}
        handleAddComment={this.props.handleAddComment}
        putVote={this.onVote}
        onFlagComment={this.props.onFlagComment}
        renderUserIcon={this.renderUserIcon}
        isValidRating={this.props.isValidRating}
        data={item}
        parentUserName={item.O_D_N || item.F_NAME}
        isParent={isParent}
        disclaimer={this.props.disclaimer}
        styles={this.props.styles}
        isPrime={this.props.isPrime}
        isWapView={this.props.isWapView}
        openCommentBox={this.state.openedAddCommentBoxId === item._id}
        resetCommentBoxId={this.resetCommentBoxId}
        errorMsg={this.state[`errorMsg-${item._id}`] || ''}
        onFlagClick={this.onFlagClick}
        shouldShowFlagForm={this.state.activeFlag === item._id}
        hideFlag={this.hideFlag}
        commentTextInputRef={this.props.commentTextInputRef}
        showVerificationMsg={this.props.showVerificationMsg}
        seoData={this.props.seoData}
        isHighlighted={this.state.highlightedId === item._id}
        level={level}
        isPrivateUser={this.props.isPrivateUser}
        isFollowee={
          this.props.followees &&
          this.props.followees.indexOf(
            item.user_detail && item.user_detail._id
              ? item.user_detail._id
              : '',
          ) !== -1
        }
        toipLayout={this.props.toipLayout}
      />
    );
  }

  getBottomCommentItem(item) {
    return (
      <BottomCommentItem
        userData={this.props.userData}
        isUserLoggedin={this.props.isUserLoggedin}
        openLoginBox={this.openLoginBox}
        pageMsid={this.props.msid}
        key={item._id}
        id={item._id}
        renderCommentList={this.renderCommentList}
        renderUserIcon={this.renderUserIcon}
        data={item}
        onClick={this.showThread}
        isPrime={this.props.isPrime}
        openAddCommentBox={this.openAddCommentBox}
        putVote={this.onVote}
        flagHandler={this.onFlagClick}
        msid={this.props.msid}
        isPrivateUser={this.props.isPrivateUser}
        toipLayout={this.props.toipLayout}
      />
    );
  }

  renderBottomComments(data) {
    return (
      <>
        {data &&
          typeof data.filter === 'function' &&
          data
            .filter(item => item._id)
            .slice(0, 3)
            .map((item, i) => this.getBottomCommentItem(item, i))}
      </>
    );
  }
  getBottomCommentItemV2(item) {
    return (
      <BottomCommentItemV2Loader
        userData={this.props.userData}
        isUserLoggedin={this.props.isUserLoggedin}
        openLoginBox={this.openLoginBox}
        pageMsid={this.props.msid}
        key={item._id}
        id={item._id}
        renderCommentList={this.renderCommentList}
        renderUserIcon={this.renderUserIcon}
        data={item}
        onClick={this.showThread}
        isPrime={this.props.isPrime}
        openAddCommentBox={this.openAddCommentBox}
        putVote={this.onVote}
        flagHandler={this.onFlagClick}
        msid={this.props.msid}
        isPrivateUser={this.props.isPrivateUser}
        toipLayout={this.props.toipLayout}
      />
    );
  }
  renderBottomCommentsV2(data) {
    return (
      <>
        {data &&
          typeof data.filter === 'function' &&
          data
            .filter(item => item._id)
            .slice(0, 3)
            .map((item, i) => this.getBottomCommentItemV2(item, i))}
      </>
    );
  }
  renderCommentList(data, parent = {}, level = 0) {
    const s = this.props.styles;
    return (
      <ul className={s.comments_lists}>
        {data &&
          typeof data.filter === 'function' &&
          data.filter(item => item._id).map((item, i) => (
            <>
              {this.getCommentItem(item, i, parent, level)}
              {i > 3 &&
                (i + 1) % 5 === 0 &&
                !this.props.isPrime && (
                  <div className="paisa-wrapper">
                    <AdCaller
                      data={{ name: 'comment_mrec' }}
                      msid={`${this.state.dynAdid}${i}`}
                      deviceType="mobile"
                      immediateLoad
                    />
                  </div>
                )}
            </>
          ))}
      </ul>
    );
  }

  hideChangeViewLoader = () => {
    this.setState({ showChangeViewLoader: false });
  };

  showChangeViewLoader = () => {
    this.setState({ showChangeViewLoader: true });
  };

  changadId = () => {
    this.setState({ dynAdid: this.state.dynAdid + 1 });
  };

  @bindGa({})
  onSortClick(event) {
    this.showChangeViewLoader();
    const selectedItem = event.target.value;
    this.props.onSortClick(selectedItem, this.hideChangeViewLoader);
    this.sortType = selectedItem;
    this.changadId();
  }

  renderSortOptions(sortData) {
    return (
      <select
        id="sort"
        data-ga={`comment-sort-comment_section|msid_${this.props.msid}`}
        onChange={this.onSortClick}
      >
        {sortData.map(item => (
          <option key={item.label} data-type={item.label}>
            {item.label}
          </option>
        ))}
      </select>
    );
  }

  renderError() {
    const { config } = this.props;
    if (config.messages.login_required) {
      // switch()
    }
    // return(

    //  )
  }

  openLoginBox() {
    if (!this.props.isUserLoggedin(this.props.userData)) {
      this.props.toggleLoginBox(true);
    }
  }

  renderLogin() {
    const isLoggedin = this.props.isUserLoggedin(this.props.userData);

    return (
      <div>
        {!isLoggedin && (
          <h3 onClick={this.openLoginBox}>Login to add a comment</h3>
        )}
      </div>
    );
  }

  getScrollHeight() {
    const documentHeight = document.documentElement.clientHeight;
    let scrollHeight;
    if (this.props.isPrime) {
      scrollHeight = documentHeight;
    } else {
      scrollHeight = documentHeight - 51;
    }

    return scrollHeight;
  }

  hideLoadMoreCommentsLoader = () => {
    this.setState({ showLoadMoreLoader: false });
  };

  @bindGa({})
  loadMoreComments() {
    this.setState({ showLoadMoreLoader: true });
    this.props.loadMoreComments(this.hideLoadMoreCommentsLoader);
  }

  getNoCommentText = () => {
    const data = this.props.commentsData || [];
    // if (data.length === 0) {
    //   return '';
    // }
    const commentsCount = (data && data[0] && data[0].totalcount) || 0;
    let text = '';
    if (commentsCount === 0) {
      text = 'Be the first one to review.';
    } else if (this.sortType === 'discussed' && !data[0].countPresent) {
      text = 'None of the comments have been discussed.';
    } else if (this.sortType === 'disagree' && !data[0].countPresent) {
      text = 'None of the comments have been down voted.';
    }

    return text;
  };

  hideFixedHeader = () => {
    this.setState({ showFixedHeader: false });
  };

  getSideBarHtml(s, data = [], parent = {}, loadMoreComments, commentsCount) {
    const noCommentText = this.getNoCommentText(commentsCount);
    return (
      <div className={s.comment_scroll}>
        <div className={s.comment_topwrite}>
          {this.props.commentModeration !== '4.0' && (
            <CommentWriteBox
              shouldAlwaysShow
              userData={this.props.userData}
              openLoginBox={this.openLoginBox}
              isUserLoggedin={this.props.isUserLoggedin}
              handleAddComment={this.props.handleAddComment}
              pageMsid={this.props.msid}
              getMsid={undefined}
              getImmediateParent={undefined}
              getParentComment={undefined}
              renderUserIcon={this.renderUserIcon}
              disclaimer={this.props.disclaimer}
              styles={s}
              prime={this.props.isPrime}
              isWapView={this.props.isWapView}
              mainCommentBox
              showFixedHeader={this.state.showFixedHeader}
              hideFixedHeader={this.hideFixedHeader}
              commentTextInputRef={this.props.commentTextInputRef}
              showVerificationMsg={this.props.showVerificationMsg}
              seoData={this.props.seoData}
              isPrivateUser={this.props.isPrivateUser}
              ref={this.childRef}
              toipLayout={this.props.toipLayout}
            />
          )}
          {!this.props.isWapView &&
            !this.props.isPrime &&
            noCommentText && <div className={s.noComment}>{noCommentText}</div>}
          {/* {this.props.isPrime &&
            commentsCount > 0 && (
              <span className={s.sortby}>
                {this.renderSortOptions(this.props.getSortTypeData())}
              </span>
            )} */}
          {this.state.showChangeViewLoader ? (
            <div className={s.loader}>
              <i />
            </div>
          ) : (
            <>{this.renderCommentList(data, parent)}</>
          )}
          {loadMoreComments && (
            <>
              {this.state.showLoadMoreLoader && (
                <div className={s.loader}>
                  <i />
                </div>
              )}
              {!this.state.showLoadMoreLoader &&
                !this.state.showChangeViewLoader && (
                  <div
                    className={s.loadmore}
                    data-ga={`comment-view_more-comment_section|msid_${
                      this.props.msid
                    }`}
                    onClick={e => this.loadMoreComments(e)}
                  >
                    View more comments
                  </div>
                )}
            </>
          )}
        </div>
      </div>
    );
  }

  @bindGa({})
  handleFixedHeader() {
    this.setState({ showFixedHeader: true, showFixedHeaderIcon: false });
  }

  isElementInViewport = el => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight ||
          document.documentElement.clientHeight) /*or $(window).height() */ &&
      rect.right <=
        (window.innerWidth ||
          document.documentElement.clientWidth) /*or $(window).width() */
    );
  };

  handleScrollStop = () => {
    const textareaElem = document.getElementById(
      `comment-sidebar-input-${this.props.msid}`,
    );

    if (textareaElem) {
      if (
        !this.isElementInViewport(textareaElem) &&
        !this.state.showFixedHeader
      ) {
        this.setState({ showFixedHeaderIcon: true });
      } else {
        this.setState({ showFixedHeaderIcon: false });
      }
    }
  };

  renderSidebar(data = [], parent = {}, loadMoreComments) {
    let commentsCount = (data[0] && data[0].totalcount) || 0;
    if (
      commentsCount > 0 &&
      data[0].topComment &&
      data[0].topComment.length > 0
    ) {
      commentsCount -= data[0].topComment.length;
    }
    const s = this.props.styles;
    const isTabletOrMobile =
      !this.props.hideBottomComments && (this.props.isWapView || isTablet());
    return (
      <>
        <div
          className={`${s.comment_header} ${this.props.isTablet ? s.ipad : ''}`}
        >
          {!this.props.isPrime ? 'All ' : ''}
          Comments <span className={s.lightText}>({commentsCount})</span>
          {!this.props.isPrime &&
            !this.props.isWapView &&
            this.state.showFixedHeaderIcon && (
              <span
                data-ga={`comment-add-comment_section|msid_${this.props.msid}`}
                className={s.addcommentheader}
                onClick={e => this.handleFixedHeader(e)}
              />
            )}
          {commentsCount > 0 && (
            <span className={s.sortby}>
              <label htmlFor="sort" className={s.sortText}>
                {' '}
                sort
              </label>
              {this.renderSortOptions(this.props.getSortTypeData())}
            </span>
          )}
          <span className={s.close} onClick={e => this.onSidebarOpenClose(e)}>
            +
          </span>
        </div>
        {isTabletOrMobile && (
          <div className={s.mobilecomment}>
            {this.getSideBarHtml(
              s,
              data,
              parent,
              loadMoreComments,
              commentsCount,
            )}
          </div>
        )}
        {!isTabletOrMobile && (
          <Scrollbars
            style={{
              height: this.getScrollHeight(),
              width: this.props.isPrime ? 430 : 425,
              flex: 1,
            }}
            universal
            onScrollStop={this.handleScrollStop}
          >
            {this.getSideBarHtml(
              s,
              data,
              parent,
              loadMoreComments,
              commentsCount,
            )}
          </Scrollbars>
        )}
      </>
    );
  }

  onSidebarOpenClose(e, isOpen) {
    const sidebarState =
      typeof isOpen === 'boolean' && isOpen
        ? isOpen
        : !(this.props.sidebarOpenMsid === this.props.msid);
    if (this.props.toipLayout) {
      this.createChildRef();
    }

    // this.setState({
    //   sidebarOpen: sidebarState,
    // });
    if (!sidebarState) {
      document.body.style.overflow = '';
    } else if (!isTablet() || this.props.hideBottomComments) {
      document.body.style.overflow = 'hidden';
    }

    if (!sidebarState) {
      document.documentElement.style.overflow = '';
    } else if (!isTablet() || this.props.hideBottomComments) {
      document.documentElement.style.overflow = 'hidden';
    }

    this.props.openSidebar(sidebarState ? this.props.msid : '');
    this.handleCallbak(sidebarState);
    this.setState({ showFixedHeader: false, highlightedId: '' });
  }

  static getSidebarStyles() {
    return {
      sidebar: {
        zIndex: 2,
        position: 'fixed',
        top: 0,
        bottom: 0,
        transition: 'transform 0.3s ease-out',
        willChange: 'transform',
        overflow: 'hidden',
        paddingRight: '0',
      },
      root: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        willChange: 'position',
        zIndex: 1002,
        left: '100%',
      },
    };
  }

  getReadCommentsBtn = commentsCount => {
    const commentsWord = commentsCount > 1 ? 'comments' : 'comment';
    const { toipLayout } = this.props;
    let readCommentsTxt =
      this.props.readCommentsTxt ||
      `View all <span>${commentsCount} ${commentsWord}<span>`;
    if (this.props.showBottomCommentsV2) {
      // if (this.props.isWapView) {
      //   readCommentsTxt = `${
      //     commentsCount > 99 ? '99+' : commentsCount
      //   } ${commentsWord}`;
      // } else {
      //   readCommentsTxt = `Read ${commentsWord} (${
      //     commentsCount > 99 ? '99+' : commentsCount
      //   })`;
      // }
      readCommentsTxt = `Read ${commentsWord} (${commentsCount})  `;
    }
    const s = this.props.styles;
    if (commentsCount !== 0) {
      if (this.props.redirectBtnClick && this.props.toipLayout) {
        // for prime users only
        const url = this.redirectToPrimeCommentSection();
        return (
          <a
            className={`${s.cmtbtn} ${s.view}`}
            href={`https://m.timesofindia.com${url}`}
          >
            {readCommentsTxt}
          </a>
        );
      } else if (this.props.redirectBtnClick && !this.props.toipLayout) {
        return (
          <a
            className={`${s.cmtbtn} ${s.view}`}
            href={`/articleshow_comments/${this.props.msid}.cms`}
          >
            {readCommentsTxt}
          </a>
        );
      }
      return (
        <span
          className={`${s.cmtbtn} ${s.view} cmtbtn view`}
          data-ga={`comment-view-below_as|msid_${this.props.msid}`}
          onClick={e => {
            if (toipLayout) {
              analyticsWrapper(
                'ga',
                'send',
                'event',
                'WEB-Prime-AS',
                'BTF-Comment',
                'Click-Read',
              );
            }
            this.readCommentHandler(e);
          }}
          dangerouslySetInnerHTML={{
            __html: readCommentsTxt,
          }}
        />
      );
    }
    return null;
  };

  @bindGa({})
  readCommentHandler(e) {
    this.onSidebarOpenClose(e, true);
  }

  @bindGa({})
  postCommentHandler(e) {
    this.onSidebarOpenClose(e, true);
    setTimeout(() => {
      // eslint-disable-next-line react/prop-types
      this.props.commentTextInputRef.current.focus();
    }, 0);
  }

  handleCallbak(sidebarState) {
    if (
      this.props.openSidebarCallback &&
      typeof this.props.openSidebarCallback === 'function'
    ) {
      this.props.openSidebarCallback(sidebarState);
    }
  }

  getPostCommentBtn = () => {
    const s = this.props.styles;
    const { toipLayout } = this.props;
    const postCommentText = this.props.postCommentText || 'Post a comment';
    if (this.props.commentModeration === '4.0') {
      return null;
    }
    if (this.props.redirectBtnClick && this.props.toipLayout) {
      // for prime users only
      const url = this.redirectToPrimeCommentSection();
      return (
        <a
          className={`${s.cmtbtn} ${s.add}`}
          href={`https://m.timesofindia.com${url}`}
        >
          <span className="icon">{postCommentText}</span>
        </a>
      );
    } else if (this.props.redirectBtnClick && !this.props.toipLayout) {
      return (
        <a
          className={`${s.cmtbtn} ${s.add}`}
          href={`/articleshow_comments/${this.props.msid}.cms`}
        >
          <span className="icon">{postCommentText}</span>
        </a>
      );
    }
    return (
      <span
        className={`${s.cmtbtn} ${s.add} cmtbtn add`}
        data-ga={`comment-add-below_as|msid_${this.props.msid}`}
        onClick={e => {
          if (toipLayout) {
            analyticsWrapper(
              'ga',
              'send',
              'event',
              'WEB-Prime-AS',
              'BTF-Comment',
              'Click-Post',
            );
          }

          this.postCommentHandler(e);
        }}
      >
        {postCommentText}
        <span />
      </span>
    );
  };
  getStartConversationBtn = () => {
    // only for prime user
    const s = this.props.styles;
    if (this.props.redirectBtnClick) {
      const url = this.redirectToPrimeCommentSection();
      return (
        <a
          className={`${s.cmtbtn} ${s.add} ${s.startComment}`}
          href={`https://m.timesofindia.com${url}`}
        >
          <span className="icon">Post a comment</span>
        </a>
      );
    }
    return (
      <span
        className={`${s.cmtbtn} ${s.add} cmtbtn add`}
        data-ga={`comment-add-below_as|msid_${this.props.msid}`}
        onClick={e => this.postCommentHandler(e)}
      >
        Post a comment<span className="icon" />
      </span>
    );
  };
  redirectToPrimeCommentSection = () => {
    let url;
    if (window.location.href.indexOf('.com') > -1) {
      url = window.location.href.split('.com')[1];
      if (url.includes('articleshow')) {
        url = url.split('articleshow')[0];
        url += `pcomments/${this.props.msid}.cms`;
      }
    }
    return url;
  };

  render() {
    const commentsData = this.props.commentsData || [];
    const commentsLoaded = commentsData.length > 0 ? commentsData.length : 0;
    let commentsCount = (commentsData[0] && commentsData[0].totalcount) || 0;
    if (
      commentsCount > 0 &&
      commentsData[0].topComment &&
      commentsData[0].topComment.length > 0
    ) {
      commentsCount -= commentsData[0].topComment.length;
    }
    const sidebarStyles = Comments.getSidebarStyles();
    const commentTickerClass = 'commentTicker';
    const sidebar = this.renderSidebar(
      commentsData,
      {},
      commentsCount > commentsLoaded,
    );

    const s = this.props.styles;
    //console.log('virendra ', this.props.msid);
    //console.log('virendra sidebarOpenMsid', this.props.sidebarOpenMsid);
    return (
      <div
        className={`${s.commentsContainer} ${
          this.props.showBottomCommentsV2 ? s.CommentLB_Bottom : ''
        } cmtwrapper`}
        id={`comment-container-${this.props.msid}`}
      >
        <>
          {!this.props.showBottomCommentsV2 &&
            this.props.isTimelineVisible && (
              <div onClick={e => this.showThread(e)}>
                <StickyDiv
                  stickyClass={s.sticky}
                  outerContainerClass={s.commentsWrapper}
                  offsetFromTop={450}
                >
                  <div
                    className={`${s.comment_title} ${
                      s[commentTickerClass]
                    } appOnlyComment`}
                  >
                    {commentsCount > 0 ? (
                      <span className={s.lightText}>{commentsCount}</span>
                    ) : (
                      <span className={s.lightText1}>+</span>
                    )}
                  </div>
                </StickyDiv>
              </div>
            )}
          {this.props.showBottomCommentsV2 && (
            <>
              <div
                className={`${s.comments_box} ${
                  commentsLoaded ? s.bottom_inner_v2 : s.noComments_v2
                } ${this.props.isGrid2Col ? '' : s.col2}`}
              >
                {commentsLoaded !== 0 ? (
                  <h4>TOP COMMENTS</h4>
                ) : (
                  <div className={s.startConversation}>
                    Start a Conversation
                  </div>
                )}
                {this.renderBottomCommentsV2(commentsData)}
                <div className={`${s.cmtbtnwrapper} ${s.LBv2}`}>
                  {this.getPostCommentBtn()}
                  {this.getReadCommentsBtn(commentsCount)}
                </div>
              </div>
            </>
          )}
          {!this.props.showBottomCommentsV2 &&
            !this.props.isTimelineVisible &&
            !this.props.hideBottomComments && (
              <>
                <div
                  className={`${s.comment_top_header} ${
                    commentsLoaded === 0 ? s.no_comments : ''
                  }`}
                >
                  <span>
                    {commentsLoaded !== 0
                      ? 'Top Comments'
                      : 'Be the first one to comment'}
                  </span>
                </div>
                {!this.props.isWapView &&
                  !this.props.isTablet &&
                  !this.props.hideBottomComments && (
                    <div className={s.comments_box}>
                      {this.renderBottomComments(commentsData)}
                    </div>
                  )}
                {!this.props.isTablet && (
                  <>
                    {commentsLoaded !== 0 ? (
                      <div className={s.cmtbtnwrapper}>
                        {this.getReadCommentsBtn(commentsCount)}
                        {this.getPostCommentBtn()}
                      </div>
                    ) : (
                      <div className={s.cmtbtnwrapper}>
                        {this.getStartConversationBtn()}
                      </div>
                    )}
                  </>
                )}
              </>
            )}
        </>

        {(!this.props.isTablet || this.props.hideBottomComments) &&
        this.props.isSidebarPortable ? (
          this.props.loadCommentsSidebarOutside(
            <div className={s.commentsContainer}>
              <Sidebar
                pullRight
                transitions
                rootClassName={`${s.root} ${
                  this.props.msid === this.props.sidebarOpenMsid ? s.open : ''
                }`}
                sidebarClassName={s.comment_sidebar}
                styles={sidebarStyles}
                sidebar={sidebar}
                onSetOpen={this.onSidebarOpenClose}
                open={
                  this.props.msid &&
                  this.props.msid === this.props.sidebarOpenMsid
                }
              />
            </div>,
          )
        ) : (
          <Sidebar
            pullRight
            transitions
            rootClassName={`${s.root} ${
              this.props.msid === this.props.sidebarOpenMsid ? s.open : ''
            }`}
            sidebarClassName={`${s.comment_sidebar} ${
              this.props.toipLayout ? s.none : ''
            }`}
            styles={sidebarStyles}
            sidebar={sidebar}
            onSetOpen={this.onSidebarOpenClose}
            open={
              this.props.msid && this.props.msid === this.props.sidebarOpenMsid
            }
          />
        )}

        {!this.props.hideBottomComments &&
          (this.props.isTablet ||
            (this.props.isPrime && this.props.isWapView)) && (
            <div className={s.commentsipad}>{sidebar}</div>
          )}
      </div>
    );
  }
}

Comments.propTypes = {
  msid: PropTypes.string.isRequired,
  userData: PropTypes.shape({}),
  commentsData: PropTypes.arrayOf(PropTypes.shape({})),
  isUserLoggedin: PropTypes.func.isRequired,
  handleAddComment: PropTypes.func.isRequired,
  putVote: PropTypes.func.isRequired,
  onFlagComment: PropTypes.func.isRequired,
  isValidRating: PropTypes.func.isRequired,
  onSortClick: PropTypes.func.isRequired,
  config: PropTypes.shape({}).isRequired,
  getSortTypeData: PropTypes.func.isRequired,
  disclaimer: PropTypes.func.isRequired,
  toggleLoginBox: PropTypes.func.isRequired,
  isTimelineVisible: PropTypes.bool,
  postCommentText: PropTypes.string,
  readCommentsTxt: PropTypes.string,
  redirectBtnClick: PropTypes.bool,
  // isWapView: PropTypes.bool,
  sidebarOpenMsid: PropTypes.string,
  openSidebar: PropTypes.func,
  loadMoreComments: PropTypes.func.isRequired,
  styles: PropTypes.shape({}).isRequired,
  isTablet: PropTypes.bool,
  isPrime: PropTypes.bool,
  isWapView: PropTypes.bool,
  commentTextInputRef: PropTypes.shape({}).isRequired,
  showVerificationMsg: PropTypes.bool,
  seoData: PropTypes.shape({}),
  commentIdHighlighted: PropTypes.number,
  hideBottomComments: PropTypes.bool,
  followees: PropTypes.arrayOf(PropTypes.number),
  isPrivateUser: PropTypes.bool,
  commentModeration: PropTypes.string,
  showBottomCommentsV2: PropTypes.bool,
  isGrid2Col: PropTypes.bool,
  isSidebarPortable: PropTypes.bool,
  loadCommentsSidebarOutside: PropTypes.func,
  toipLayout: PropTypes.bool,
  openSidebarCallback: PropTypes.func,
};

Comments.defaultProps = {
  userData: undefined,
  commentsData: undefined,
  isTimelineVisible: false,
  postCommentText: undefined,
  readCommentsTxt: undefined,
  redirectBtnClick: false,
  // isWapView: false,
  sidebarOpenMsid: '',
  openSidebar: () => {},
  isTablet: false,
  isPrime: false,
  isWapView: false,
  showVerificationMsg: false,
  seoData: {},
  commentIdHighlighted: -1,
  hideBottomComments: false,
  followees: [],
  isPrivateUser: true,
  commentModeration: '',
  showBottomCommentsV2: false,
  isGrid2Col: false,
  isSidebarPortable: false,
  loadCommentsSidebarOutside: () => null,
  toipLayout: false,
  openSidebarCallback: () => null,
};

export default Comments;
